import { graphql } from "gatsby";
import React, { FC } from "react";

import { useLabels } from "../../../contexts/labels";
import { renameFields } from "../../../utils/object";
import { StoreLocator, StoreLocatorProps } from "./store-locator";

export interface StoreLocatorSectionProps {
  items: Queries.CompanySiteDetailDataFragment[];
}

export const StoreLocatorSection: FC<StoreLocatorSectionProps> = ({ items: stores }) => {
  const { labels: stringLabels } = useLabels();

  const fieldsToRename: Record<keyof StoreLocatorProps["labels"], string | null> = {
    "store-locator-title": null,
    "store-locator-results-count": null,
    "store-locator-store-open": null,
    "store-locator-store-closed": null,
    "store-locator-store-address": null,
    "store-locator-store-contacts": null,
    "store-locator-store-timetable": null,
    "store-locator-store-directions": null,
    "store-locator-store-fax": null,
    "store-locator-store-phone": null,
    "store-locator-store-email": null,
    // "store-locator-store-contact-cta": null,
    "store-locator-search-placeholder": null,
    "store-locator-search-empty-state": null,
    "store-locator-search-company-type-label": null,
    "store-locator-store-opens-at": null,
    "store-locator-store-closes-at": null,
    "company-site-types-biesse": null,
    "company-site-types-biesse-venue": null,
    "company-site-types-dealer": null,
    "company-site-types-production-site": null,
    "store-locator-map-title": null,
    "store-locator-list-title": null,
  };

  const labels = renameFields(stringLabels, fieldsToRename) as StoreLocatorProps["labels"];

  return <StoreLocator stores={stores} labels={labels} />;
};

export const query = graphql`
  fragment CompanySiteDetailData on ContentfulCompanySite {
    id
    siteType
    internalName
    node_locale
    name
    description {
      raw
    }
    address
    city
    country
    state
    zipCode
    email
    fax
    phone
    timezone
    lat
    lng
    isHQ
    # timetable
    mondayOpensAt
    mondayClosesAt
    tuesdayOpensAt
    tuesdayClosesAt
    wednesdayOpensAt
    wednesdayClosesAt
    thursdayOpensAt
    thursdayClosesAt
    fridayOpensAt
    fridayClosesAt
    saturdayOpensAt
    saturdayClosesAt
    sundayOpensAt
    sundayClosesAt
  }
`;
